<template>
    <div v-if="product.info">
        <h1 class="text-h6">
            {{ product.info.name }}
        </h1>
        <div v-if="product.shortDescription" v-html="product.shortDescription" />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    //TODO Remove this component (not used)
    @Component
    export class ActivityInfo extends Vue {
        @Prop({
            required: true,
        })
        product
    }

    export default ActivityInfo
</script>
